import { FC } from 'react';
import { Panel } from 'rsuite';
import { IApplicationSummary } from '../store/merchnts/merchant-interfaces';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { IApplicationFilters } from '../store/merchnts/actions/application';
import { makeSearchParams, parseSearchParams } from '../utils/utilities';
import { useMerchants } from '../store/merchnts/merchants-context';
import { APPLICATION_SUMMARY } from '../utils/applicationsListUtils';

import './PageSummaryComponent.scss';
interface Props {
  componentTitle: string;
  data: IApplicationSummary[];
  defaultExpanded?: boolean;
}
export const PageSummaryComponent: FC<Props> = (props) => {
  const { componentTitle, data, defaultExpanded = true } = props;

  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const { merchantState: { merchantsLists }} = useMerchants();

  const savedApplicationFilters: IApplicationFilters = parseSearchParams(search) || {};

  const handleItemClick = (title: string): void => {
    const params = savedApplicationFilters;

    switch (title) {
      case APPLICATION_SUMMARY.RISK: {
        params.riskStatuses = merchantsLists?.applicationRiskStatuses
          ?.filter(({ value }) => value !== 'Approved')
          ?.map(({ value }) => value);

        break;
      }

      case APPLICATION_SUMMARY.OPERATIONS: {
        params.operationsStatuses = merchantsLists?.applicationOperationsStatuses
          ?.filter(({ value }) => value !== 'Completed')
          ?.map(({ value }) => value);

        break;
      }

      default:
        break;
    }

    navigate(`${pathname}?${makeSearchParams(params)}`);
  };

  return (
    <div className="mb-5">
      <Panel header={componentTitle} collapsible defaultExpanded={defaultExpanded} className="follow-up pt-0">
        <div className="d-flex align-items-center flex-wrap mt-2">
          {data.map(({ label, value, title }) => (
            <div
              key={title}
              className="card me-5"
            >
              <div
                className="card-body p-5 cursor-pointer application-summary-item"
                onClick={(): void => handleItemClick(title)}
              >
                <div className="fs-7 mb-2">{title}</div>
                <div className="d-flex align-items-center">
                  <div className="fs-6 fw-bolder me-2">{value}</div>
                  <div className="fs-8 text-muted">{label}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
};